import React from "react";
import SeoPage from "../../components/SeoPage";
import RELATED from "../../data/related";
import { faqsByTopic } from "../../data/faqs";

export default function PrivacyFocusedCsvViewer() {
    return (
        <SeoPage
            title="Privacy-Focused CSV Viewer — Your Files Stay Yours"
            description="OpenCSV processes your CSV files locally in your browser by default. No tracking, no ads, no analytics on file content. Optional cloud save when you want it."
            breadcrumbs={[{ label: "Home", href: "/" }, { label: "Privacy-Focused CSV Viewer" }]}
            eyebrow="/ feature"
            h1="A CSV viewer that respects your data"
            heroLead="Your spreadsheets often contain customer info, financial records, or internal data that shouldn't leave your machine without a good reason. OpenCSV is built so the default is privacy — uploads only happen when you explicitly choose to."
            sections={[
                { heading: "How OpenCSV handles your files",
                    bullets: [
                        "Local-first: opening a CSV runs entirely in your browser. The file never leaves your device.",
                        "No telemetry on file content. Ever.",
                        "No third-party analytics or ad networks (no Google Analytics, no Facebook Pixel, no Mixpanel)",
                        "Single httpOnly session cookie for keeping you logged in — that's the only cookie",
                        "Cloud save is opt-in: only files you explicitly save end up on our servers",
                        "All cloud data uses HTTPS in transit",
                    ],
                },
                { heading: "What we do collect",
                    body: "Being honest matters. Here's the full list:",
                    bullets: [
                        "Your email and a hashed password (or Google profile if you sign in with Google)",
                        "A timestamp for when you signed up and when you last logged in",
                        "Your subscription / payment record (handled by Stripe; we never see your card number)",
                        "Server logs (IP + URL path) for 30 days, used only for debugging",
                    ],
                    callout: "That's it. No clickstream tracking, no behavioural analytics on what you do inside the editor, no cross-site profiling."
                },
                { heading: "Read our Privacy Policy", body: "We don't bury anything legalese-deep. Our Privacy Policy is short, in plain English, and tells you exactly what we collect and why." },
                { heading: "Why this matters", body: "Spreadsheets are where companies leak data. Customer exports, financial summaries, employee records — they end up in shared inboxes, public Slack channels, and free online 'CSV viewers' that quietly upload everything to a third-party server. OpenCSV is built so that doesn't happen by default." },
            ]}
            faqs={faqsByTopic("privacy", "general")}
            related={[RELATED.viewer, RELATED.editor, RELATED.light, RELATED.faq, RELATED.use, RELATED.impexp]}
        />
    );
}
